var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages.length > 0)?_c('span',_vm._l((_vm.messages),function(message,i){return _c('b-alert',{key:i,attrs:{"variant":message.variant,"show":""},domProps:{"innerHTML":_vm._s(message.text)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }